/// <amd-module name="Feed/Legacy/Actions/FeedActionCreator" />
import { IVssPageContext } from "VSS/Platform/Context";
import { Action } from "VSS/Reflux/Action";

import { PackageManagementSettingsDialogHandler } from "Feed/Legacy/Actions/FeedList/PackageManagementSettingsDialogHandler";

export class FeedActionCreator {
    /**
     * User clicked on Settings icon and selected Global settings, show global Azure Artifacts SettingsDialog
     */
    public showPackageManagementSettingDialog: Action<{}>;

    constructor(pageContext: IVssPageContext) {
        this.pageContext = pageContext;
    }

    public initializeListeners(): void {
        this.showPackageManagementSettingDialog = new Action<{}>();
        this.showPackageManagementSettingDialog.addListener(this.showSettingsDialog);
    }

    public detachListeners(): void {
        this.showPackageManagementSettingDialog.removeListener(this.showSettingsDialog);
    }

    // Delete this method after Redux-based global setting panel is deployed out
    // (and GlobalPermissionsMapWellKnownIdentifier feature flag is enabled everywhere)
    private showSettingsDialog = (): void => {
        PackageManagementSettingsDialogHandler.Open(this.pageContext);
    };

    private pageContext: IVssPageContext;
}
